import { SEARCH_REQUESTED } from "./const";

/**
 * action creator for search request
 *
 * @returns {type: {string, query: {Query}}}
 */
const action = (filters, updateType = "replace") => {
  return {
    type: SEARCH_REQUESTED,
    filters,
    updateType,
  };
};

export default action;
